/* globals App */

export default class GetInTouch {
  constructor($elem) {
    this.$elem = $elem;
    this.$elem
      .find("form")[0]
      .addEventListener("freeform-ajax-after-submit", () => {
        App.getForms().then(() => {
          App.forms.initSelects(this.$elem.find("form select"));
        });
      });
  }
}
